import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useTheme } from "../../context/ThemeContext";
import { getVisibleSections } from "../../lib/windowManager/registry";
import { Sheet, SheetContent, SheetTrigger } from "../ui/sheet";
import { Sun, Moon, LogOut, User } from "lucide-react";

// Mobile bottom chrome: a horizontally-scrolling section nav that replaces the
// desktop taskbar, plus an account sheet (theme toggle + logout).
export default function MobileChrome() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAdmin, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [accountOpen, setAccountOpen] = useState(false);

  const sections = getVisibleSections(isAdmin);

  function go(route) {
    if (route !== location.pathname) navigate(route);
  }

  function handleLogout() {
    setAccountOpen(false);
    logout();
    navigate("/login");
  }

  return (
    <div className="win98-mobile-bottombar">
      <nav className="win98-mobile-nav" aria-label="Site navigation">
        {sections.map((entry) => {
          const active = location.pathname.startsWith(entry.route);
          return (
            <button
              key={entry.id}
              type="button"
              className={`win98-quicklink win-btn${active ? " win98-taskbar-item--active" : ""}`}
              onClick={() => go(entry.route)}
              data-testid={`mobile-nav-${entry.id}`}
            >
              <span aria-hidden="true">{entry.icon}</span> {entry.title}
            </button>
          );
        })}
        <Sheet open={accountOpen} onOpenChange={setAccountOpen}>
          <SheetTrigger asChild>
            <button type="button" className="win98-quicklink win-btn" aria-label="Account" data-testid="mobile-account">
              <User className="w-4 h-4" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="win-window w-72">
            <div className="win-titlebar mb-4">
              <span>Account</span>
            </div>
            <div className="px-2 space-y-2">
              <div className="win-well p-3">
                <p className="font-medium truncate">{user?.name}</p>
                <p className="text-xs text-muted-foreground capitalize">{user?.role}</p>
              </div>
              <button type="button" className="win-btn w-full flex items-center justify-center gap-2" onClick={toggleTheme}>
                {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
                {theme === "dark" ? "Light Win98" : "Dark Win98"}
              </button>
              <button
                type="button"
                className="win-btn w-full flex items-center justify-center gap-2"
                onClick={handleLogout}
                data-testid="mobile-logout"
              >
                <LogOut className="w-4 h-4" />
                Log Off
              </button>
            </div>
          </SheetContent>
        </Sheet>
      </nav>
      <div className="win98-mobile-copyright">© KyberBusiness</div>
    </div>
  );
}
